import {
    global,
    lazyloader,
    hero,
    pillars,
    stats,
    nav,
    map,
    testimonials,
    download,
    video,
    brandslider,
    dashboard,
    dealerNav,
    sidecart,
    portalSlider,
    footer,
    industry,
    infoSlider,
    warrantyApp,
    warrantyViewAll,
    shipAndBilling,
    review,
    login,
    cart,
    orderDetails,
    orderConfirmation,
    paginationList,
    payments,
    orderHistory,
    backorders,
    invoiceHistory,
    training,
    forgot,
    register,
    myAccount,
    uploadOrder,
    modal,
    user,
    contact,
    career,
    datePicker,
    dailyPromo,
    statusBar,
    fiddle,
    registeredEvents,
    products,
    loginasdealer,
    partSmart,
} from 'js';

const modules = [
    {
        module: lazyloader,
        el: '.lazyload',
    },
    {
        module: hero,
        el: '.hero',
    },
    {
        module: pillars,
        el: '.pillars',
    },
    {
        module: stats,
        el: '.stats',
    },
    {
        module: nav,
        el: '.nav',
    },
    {
        module: map,
        el: '.map',
    },
    {
        module: testimonials,
        el: '.tm',
    },
    {
        module: download,
        el: '.dl',
    },
    {
        module: video,
        el: '.cta-video',
    },
    {
        module: brandslider,
        el: '.brand-slider',
    },
    {
        module: dashboard,
        el: '.db',
    },
    {
        module: dealerNav,
        el: '.db-nav',
    },
    {
        module: sidecart,
        el: '.sidecart',
        disableif: '[disable-sidecart]',
    },
    {
        module: portalSlider,
        el: '.portal-slider',
    },
    // {
    //   module: orderBuilder,
    //   el: '.js--ob',
    // },
    // {
    //   module: orderBuilder2,
    //   el: 'order-builder-search',
    // },
    {
        module: footer,
        el: '.js--footer-bc',
    },
    {
        module: industry,
        el: '.industry',
    },
    {
        module: infoSlider,
        el: '.infoslider',
    },
    {
        module: warrantyApp,
        el: '#warranty_app',
    },
    {
        module: warrantyViewAll,
        el: '.js--warranty-view-all',
    },
    {
        module: shipAndBilling,
        el: '.js--ship-and-billing',
    },
    {
        module: review,
        el: '.js--review',
    },
    {
        module: login,
        el: '.js--login-main',
    },
    {
        module: cart,
        el: '.js--checkout-list-products',
    },
    {
        module: orderConfirmation,
        el: '.js--order-confirmation',
    },
    {
        module: paginationList,
        el: '.js--pagination-list, .js--pagedDocumentList',
    },
    {
        module: payments,
        el: '.js--payments',
    },
    {
        module: orderHistory,
        el: '.js--oh-mini',
    },
    {
        module: training,
        el: '.js--training',
    },
    {
        module: forgot,
        el: '.js--login-forgot',
    },
    {
        module: register,
        el: '.js--register',
    },
    {
        module: myAccount,
        el: '.js--account',
    },
    {
        module: orderDetails,
        el: '#order-details',
    },
    {
        module: uploadOrder,
        el: '.js--upload-order',
    },
    {
        module: modal,
        el: '.js--pd-modal',
    },
    {
        module: user,
        el: '.js--db-content',
    },
    {
        module: contact,
        el: '.js--contact-public',
    },
    {
        module: career,
        el: '.js--career',
    },
    {
        module: datePicker,
        el: '.pd-date',
    },
    {
        module: dailyPromo,
        el: '.js--daily-promo',
    },
    {
        module: statusBar,
        el: '.alert-bar',
    },
    {
        module: global,
    },
    {
        module: fiddle,
        el: '.fiddle',
    },
    {
        module: registeredEvents,
        el: '.js--registered-events',
    },
    // documentList is now a side-effect-only import (auto-initializes)
    {
        module: products,
        el: '.js-card-single',
    },
    {
        module: loginasdealer,
        el: '.js--login-as-dealer',
    },
    {
        module: partSmart,
        el: '.js--partsmart',
    },
];

export default modules;
